projectFunctions.productSoftHardTabsFunctions = projectFunctions.productSoftHardTabsFunctions || {};

projectFunctions.productSoftHardTabsFunctions.init = function() {
    projectFunctions.productSoftHardTabsFunctions.bindTabs();
};

projectFunctions.productSoftHardTabsFunctions.bindTabs = function() {
    $('[data-product-soft-hard-tabs]').each(function() {
        var $tabs = $(this);
        var $softPanel = $tabs.find('[data-product-tab-panel="soft"]');
        var $hardContent = projectFunctions.productSoftHardTabsFunctions.getHardContent($tabs);

        $tabs.find('[data-product-tab-target]').on('click', function() {
            var $button = $(this);
            var target = $button.data('product-tab-target');

            if ($button.hasClass('is-active')) {
                return;
            }

            $tabs.find('[data-product-tab-target]')
                .removeClass('is-active')
                .attr('aria-selected', 'false');

            $button
                .addClass('is-active')
                .attr('aria-selected', 'true');

            if (target === 'soft') {
                $hardContent.attr('hidden', true);
                $softPanel.addClass('is-active').removeAttr('hidden');
            } else {
                $softPanel.removeClass('is-active').attr('hidden', true);
                $hardContent.removeAttr('hidden');
            }

            $(window).trigger('resize');
        });
    });
};

projectFunctions.productSoftHardTabsFunctions.getHardContent = function($tabs) {
    var hardSelector = $tabs.data('hard-selector');

    if (hardSelector) {
        return $(hardSelector);
    }

    var $anchor = $tabs.closest('.elementor-widget-shortcode');

    if (!$anchor.length) {
        $anchor = $tabs;
    }

    while ($anchor.parent().length && !$anchor.nextAll().length) {
        var $parent = $anchor.parent();

        if ($parent.is('body') || $parent.hasClass('elementor')) {
            break;
        }

        $anchor = $parent;
    }

    return $anchor.nextAll();
};
